import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CommonModule, DatePipe, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { OwlModule } from 'ngx-owl-carousel';
import { StoreModule } from '@ngrx/store';
import { Pagereducer } from './Store/PageStore/Page.Reducer';
import { localStorageSync } from 'ngrx-store-localstorage';
import { NgxContentLoadingModule } from 'ngx-content-loading';
import { BranchesComponent } from './branches/branches.component';
import { UserRegistrationComponent } from './user-registration/user-registration.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './login/login.component';
import { NgxPayPalModule } from 'ngx-paypal';
import { NgxAuthorizenetModule } from 'ngx-authorizenet';
import { APP_INITIALIZER } from '@angular/core';
import { ServerSettings } from './model/server-settings';
import { EditprofileComponent } from './editprofile/editprofile.component';
import { MyordersComponent } from './myorders/myorders.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { HolidayPageComponent } from './holiday-page/holiday-page.component';

export function localStorageSyncReducer(rootReducer: any)
 {
  return localStorageSync({ keys: ['MSFOO'], rehydrate: true })(rootReducer);
}
@NgModule({
  declarations: [
    AppComponent,BranchesComponent, UserRegistrationComponent, LoginComponent,EditprofileComponent,MyordersComponent, PageNotFoundComponent, HolidayPageComponent
  ],
  imports: [
    NgxContentLoadingModule,
    BrowserModule,
    NgxAuthorizenetModule,
    NgxPayPalModule,
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    OwlModule,

    StoreModule.forRoot({MSFOO: Pagereducer
    
    
    },{
      metaReducers:[localStorageSyncReducer]
    }),
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: resourceProviderFactory,
      deps: [ServerSettings],
      multi: true
      },
    
    
    DatePipe, {provide: LocationStrategy, useClass: HashLocationStrategy}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
export function resourceProviderFactory(provider: ServerSettings) {

  return () => provider.getSettings();
  }